import Vue from 'vue'
import App from './App.vue'
import router from './router/router.js'
import store from './store/index'
import { BootstrapVue } from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserCircle,faBars,faBell,faUser,faSearch,faChevronRight,faChevronDown,faClipboardList,faTools,faEye,faUserCog,
faExpand,faEdit,faTrashAlt,faChevronLeft,faCalendarDay,faHome,faPrint,faDownload,faPlus,faArrowLeft , faArrowDown,faChevronUp, faFilePdf, faFileExcel} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faUserCircle,faHome,faBars,faBell,faUser,faSearch,faChevronRight,faChevronDown,faClipboardList,
  faTools,faEye,faUserCog,faExpand,faEdit,faTrashAlt,faChevronLeft,faCalendarDay,faPrint,faDownload,faPlus,faArrowLeft, faArrowDown,faChevronUp,faFilePdf, faFileExcel)
  import 'bootstrap/dist/css/bootstrap.css'
  import 'bootstrap-vue/dist/bootstrap-vue.css'
  
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.component('font-awesome-icon', FontAwesomeIcon)
new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
